export default __webpack_public_path__ + "static/media/user-correct-position.aee7e83e.svg";